module.exports = __webpack_public_path__ + "922ceaa855b4e6eebe16bdaec85f3138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/desktop-background.jpg
// module id = 1442
// module chunks = 47